import { useState, useEffect } from 'react';

interface RecentSearch {
  destination: string;
  country: string;
  timestamp: number;
}

const MAX_RECENT_SEARCHES = 5;
const STORAGE_KEY = 'odyvoy_recent_searches';

export function useRecentSearches() {
  const [recentSearches, setRecentSearches] = useState<RecentSearch[]>([]);

  useEffect(() => {
    loadRecentSearches();
  }, []);

  const loadRecentSearches = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setRecentSearches(JSON.parse(stored));
      }
    } catch (error) {
      console.error('Error loading recent searches:', error);
    }
  };

  const addRecentSearch = (destination: string, country: string) => {
    try {
      const newSearch: RecentSearch = {
        destination,
        country,
        timestamp: Date.now()
      };

      const filtered = recentSearches.filter(
        (search) => 
          search.destination.toLowerCase() !== destination.toLowerCase() ||
          search.country.toLowerCase() !== country.toLowerCase()
      );

      const updated = [newSearch, ...filtered].slice(0, MAX_RECENT_SEARCHES);
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      setRecentSearches(updated);
    } catch (error) {
      console.error('Error saving recent search:', error);
    }
  };

  const clearRecentSearches = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      setRecentSearches([]);
    } catch (error) {
      console.error('Error clearing recent searches:', error);
    }
  };

  return {
    recentSearches,
    addRecentSearch,
    clearRecentSearches
  };
}
